import { useEffect, useState } from "react";

import { getSasTokenForEvidence } from "../services/svt/svt-user";

const useGetSasTokenForEvidence = () => {
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        const fetchSasToken = async () => {
            try {
                setLoading(true);
                const token = await getSasTokenForEvidence();
                setData(token?.data);
            } catch (error) {
                setData("");
            } finally {
                setLoading(false);
            }
        };
        fetchSasToken();
    }, []);

    return [data, loading];
};

export default useGetSasTokenForEvidence;
